import './App.css';
import ImageGenerator from './components/ImageGenerator/ImageGenerator';

function App() {
  return (
    <div> 
      <ImageGenerator/>
    </div>
  );
}

export default App;

